function Footer() {
  return (
    <footer className="mt-auto py-5 bg-dark">
      <div className="container d-flex justify-content-center">
        <span className="text-muted">Derechos Reservados &copy; Carly Fernández 2022</span>
      </div>
    </footer>
  );
}

export default Footer;
